import IntroductionContent from "./content/IntroductionContent";
import MessagesContent from "./content/MessagesContent";
import GroupMessagesContent from "./content/GroupMessagesContent";
import ImageDocumentContent from "./content/ImageDocumentContent";
import GroupsContent from "./content/GroupsContent";
import GroupContent from "./content/GroupContent";
import ChatContent from "./content/ChatContent";
import DefaultContent from "./content/DefaultContent";

const MainContent = ({
  activeSection,
  setActiveSection,
  copiedCode,
  copyToClipboard,
  activeLang,
  setActiveLang,
  CopyButton, // in case you want to pass this down to content blocks that need copy UI
}) => {
  switch (activeSection) {
    case "introduction":
      return <IntroductionContent setActiveSection={setActiveSection} />

    case "messages":
      return (
        <MessagesContent
          activeLang={activeLang}
          setActiveLang={setActiveLang}
          copiedCode={copiedCode}
          copyToClipboard={copyToClipboard}
          CopyButton={CopyButton}
        />
      );

    case "group-messages":
      return (
        <GroupMessagesContent
          activeLang={activeLang}
          setActiveLang={setActiveLang}
          copiedCode={copiedCode}
          copyToClipboard={copyToClipboard}
          CopyButton={CopyButton}
        />
      );

    case "send-file":
      return (
        <ImageDocumentContent
          activeLang={activeLang}
          setActiveLang={setActiveLang}
          copiedCode={copiedCode}
          copyToClipboard={copyToClipboard}
          CopyButton={CopyButton}
        />
      );

    case "get-chats":
      return (
        <ChatContent
          activeLang={activeLang}
          setActiveLang={setActiveLang}
          copiedCode={copiedCode}
          copyToClipboard={copyToClipboard}
          CopyButton={CopyButton}
        />
      );

    case "get-all-groups":
      return (
        <GroupsContent
          activeLang={activeLang}
          setActiveLang={setActiveLang}
          copiedCode={copiedCode}
          copyToClipboard={copyToClipboard}
          CopyButton={CopyButton}
        />
      );

    case "get-group-details":
      return (
        <GroupContent
          activeLang={activeLang}
          setActiveLang={setActiveLang}
          copiedCode={copiedCode}
          copyToClipboard={copyToClipboard}
          CopyButton={CopyButton}
        />
      );

    default:
      return <DefaultContent setActiveSection={setActiveSection} />;
  }
};

export default MainContent;
